/* eslint-disable */
export default function( element ) {
  const markup = ' \
<div class="modal fade utabHinweisModal" id="utabHinweisModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="utabHinweisModal" aria-hidden="true">\
  <div class="modal-dialog">\
    <div class="modal-content d-ibl">\
    <div class="col-xs-5 bg-image"></div>\
      <div class="modal-header">\
        <button type="button" class="close text-right blocker-btn" data-dismiss="modal"><span class="fs14">close</span></button>\
      </div>\
      <div class="col-xs-7 fl-right"><div class="modal-body txt-center">\
        <div class="h3 roboto pt10">Ads may be annoying. But they also fund utopia.org.\n</div>\
        <p class="fs14">So please support our team by allowing your browser to show ads on our website. It’ll only take a click.</p>\
        <a href="https://utopia.org/guide/deactivating-adblocker-utopia-org/" class="OrangeAutowidth blocker-btn fs14" target="_blank">Yes, I will make an exception for you.</a>\
        <p><a class="blocker-btn fs14 bb pointer" data-dismiss="modal">Nope, I don’t care.</a></p>\</div>\</div>\
    </div>\
  </div>\
</div>';
  element.append( markup );
}
